export async function askLocation({
  maxAttempts = 3,
  delayMs = 1000,
  desiredAccuracy = 20,
  maxAccuracy = 50
} = {}) {
  if (!navigator.geolocation) {
    throw { code: 'NO_GEO', message: 'Geolocation not supported' };
  }

  if (document.hidden) {
    return
  }

  const options = {
    enableHighAccuracy: true,
    maximumAge: 0,
    timeout: 10000
  };

  const getPosition = () =>
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });

  const readings = [];

  for (let i = 0; i < maxAttempts; i++) {
    try {
      const pos = await getPosition();
      const coords = pos.coords;
      readings.push(coords);

      if (coords.accuracy <= desiredAccuracy) {
        break;
      }

      await new Promise((r) => setTimeout(r, delayMs));
    } catch (err) {
      if (i === 0) throw err;
    }
  }

  if (!readings.length) {
    throw { code: 'NO_VALID_READING', message: 'No valid location data received.' };
  }

  const best = readings.reduce((prev, curr) =>
    curr.accuracy < prev.accuracy ? curr : prev
  );

  if (best.accuracy > maxAccuracy) {
      throw { code: 'ACCURACY_NOT_MET', message: `Best accuracy ${best.accuracy} exceeds desired ${desiredAccuracy}` };
  }

  return {
    latitude: best.latitude,
    longitude: best.longitude,
    accuracy: best.accuracy
  };
}
